import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Contact } from 'app/models/dto/contact.model';
import { Select, Store } from '@ngxs/store';
import { CreateContact, SetNewContact, UnsetNewContact } from 'ng2-app/store/contact/contact.actions';
import { ContactState } from 'app/store/contact/contact.state';
import { Observable } from 'rxjs';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';
import { NonOwnerPersonnelState } from 'app/store/non-owner-personnel/non-owner-personnel.state';
import { NonOwnerPersonnel } from 'app/models/dto/non-owner-personnel.model';
import { CreateNonOwnerPersonnel, SetNewNonOwnerPersonnel, UnsetNewNonOwnerPersonnel } from 'app/store/non-owner-personnel/non-owner-personnel.actions';


@Component({
  selector: 'app-add-personnel-smart',
  templateUrl: './add-personnel-smart.component.html',
  styleUrls: ['./add-personnel-smart.component.scss']
})
export class AddPersonnelSmartComponent implements OnInit, OnChanges {

  @Select(ContactState.saving) saving$: Observable<{ saving: boolean, contactId: number | string }>;
  @Select(NonOwnerPersonnelState.processing) processing$: Observable<{ saving: boolean, nonOwnerPersonnelId: number | string }>;

  @Input() contact: Contact;
  @Input() nonOwnerPersonnel: NonOwnerPersonnel;
  @Input() borrowerId: number;

  isAnOwner: boolean = false;
  somethingIsSaving$: Observable<{ saving: boolean, contactId: number | string }>;

  constructor (
    private store: Store,
    private localeSettingService: LocaleSettingService,
  ) { }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
      if (changes.contact && !!this.contact) {
        this.contact.country = this.localeSettingService.getLocaleFromPostalCode(this.contact.zipId);
      }
  }

  saveContact(contact: Contact) {
    contact.borrowerId = this.borrowerId;
    this.store.dispatch(new CreateContact(contact));
  }

  saveNonOwnerPersonnel(nonOwnerPersonnel: NonOwnerPersonnel) {
    nonOwnerPersonnel.borrowerId = this.borrowerId;
    this.store.dispatch(new CreateNonOwnerPersonnel(nonOwnerPersonnel));
  }

  cancel() {
    this.store.dispatch(new UnsetNewNonOwnerPersonnel);
    this.store.dispatch(new UnsetNewContact);
  }

  toggleIsAnOwner(isAnOwner: boolean) {
    this.isAnOwner = isAnOwner;
    // Destroy empty state object(s) and create the new one(s)
    if (this.isAnOwner) {
        this.store.dispatch(new UnsetNewNonOwnerPersonnel);
        this.store.dispatch(new SetNewContact);
      } else {
        this.store.dispatch(new UnsetNewContact);
        this.store.dispatch(new SetNewNonOwnerPersonnel);
      }
  }

}
